var map = {
	"./action_img.png": 95,
	"./background.png": 305,
	"./banner_shap.png": 306,
	"./cloud-computing.png": 307,
	"./cloud_01.png": 96,
	"./cloud_02.png": 97,
	"./cloud_03.png": 98,
	"./cloud_04.png": 99,
	"./cloud_05.png": 100,
	"./cloud_06.png": 101,
	"./crm_img1.jpg": 308,
	"./crm_img2.jpg": 309,
	"./crm_img3.jpg": 310,
	"./erp_dashboard.jpg": 102,
	"./erp_icon1.png": 311,
	"./erp_icon2.png": 312,
	"./erp_icon3.png": 313,
	"./erp_icon4.png": 314,
	"./erp_icon5.png": 315,
	"./erp_icon6.png": 316,
	"./growth.png": 317,
	"./img/01.png": 103,
	"./img/02.png": 104,
	"./img/03.png": 105,
	"./img/04.png": 106,
	"./img/05.png": 107,
	"./img/06.png": 108,
	"./img/07.png": 109,
	"./img/08.png": 110,
	"./img/09.png": 111,
	"./img/10.png": 112,
	"./img/11.png": 113,
	"./img/12.png": 114,
	"./img/13.png": 115,
	"./img/14.png": 116,
	"./img/15.png": 117,
	"./img/16.png": 118,
	"./img/17.png": 119,
	"./img/18.png": 120,
	"./img/19.png": 121,
	"./img/20.png": 122,
	"./quote.png": 318,
	"./rocket.png": 123,
	"./settings1.png": 319,
	"./shape.png": 320,
	"./testimonial_img.jpg": 321,
	"./testimonial_img2.jpg": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;